import { AHText, Box, useTheme } from "arkh";
import { View } from "react-native";
import React from "react";
import { TaskTypeIcon, TaskTypeIconSize } from "../../../types/TaskTypeIcon";
import Color from "color";
import { graphql, useFragment } from "react-relay";
import { RoutineOccasionFollowupSections_routine$key } from "./__generated__/RoutineOccasionFollowupSections_routine.graphql";
import {
  sectionHeight,
  taskHeaderHeight,
  taskResultHeight,
  taskSpaceHeight,
} from "./taskHeaderHeight";

export function RoutineOccasionFollowupSections(props: {
  routine: RoutineOccasionFollowupSections_routine$key;
}) {
  const routine = useFragment(
    graphql`
      fragment RoutineOccasionFollowupSections_routine on Routine {
        activeSections(endAt: $endAt, startAt: $startAt) {
          id
          assignedTeam {
            id
            name
          }
          lastVersion {
            id
            title
            tasks {
              __typename
              ... on TaskNumber {
                unit
              }
              ... on TaskCheck {
                sentiments
              }
              id
              title
            }
          }
        }
      }
    `,
    props.routine
  );

  const theme = useTheme();
  const backgroundColor = Color(theme.background)
    .mix(Color(theme.surface), 0.5)
    .toString();

  return (
    <>
      {routine.activeSections.map((s) => {
        return (
          <View key={s.id}>
            <View
              style={{
                height: sectionHeight,
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AHText
                type="title-small"
                style={{
                  position: "absolute",
                  top: taskHeaderHeight - 20,
                  zIndex: 1,
                }}
              >
                {s.lastVersion.title && s.lastVersion.title.length > 0
                  ? s.lastVersion.title
                  : (s.assignedTeam?.name ?? "")}
              </AHText>
            </View>
            {s.lastVersion.tasks.map((task) => (
              <View key={task.id}>
                <Box
                  style={{
                    height: taskHeaderHeight,
                    overflow: "hidden",
                    backgroundColor,
                    justifyContent: "center",
                  }}
                >
                  <Box spaceLeft="large" style={{ flexDirection: "row" }}>
                    <TaskTypeIcon
                      size={TaskTypeIconSize.XXSMALL}
                      type={
                        task.__typename === "TaskNumber"
                          ? { __typename: "TaskNumber", unit: task.unit }
                          : task.__typename === "TaskCheck"
                            ? {
                                __typename: "TaskCheck",
                                sentiments:
                                  task.sentiments?.length === 2
                                    ? ["NEGATIVE", "POSITIVE"]
                                    : ["POSITIVE"],
                              }
                            : { __typename: "TaskText" }
                      }
                    />
                    <AHText spaceLeft="small" type="subtitle">
                      {task.title}
                    </AHText>
                  </Box>
                </Box>
                <Box style={{ height: taskResultHeight }} color="lightText" />
                <Box style={{ height: taskSpaceHeight }} />
              </View>
            ))}
          </View>
        );
      })}
    </>
  );
}
